import { type TravelTicketOptionConstructor } from '@webapp/modules/expense/entities/TravelTicketOption'
import { type TravelTicketOptionApiModel } from '../api-models/TravelTicketOptionApiModel'

export const mapTravelTicketOptionApiModel = (
  apiModel: TravelTicketOptionApiModel
): TravelTicketOptionConstructor => ({
  id: apiModel.id,
  uuid: apiModel.uuid,
  purpose: apiModel.purpose,
  status: apiModel.status,
})
